import React from 'react';
import { useNavigate } from 'react-router-dom';
import FeaturedSolutions, { AgilysysLogo } from '../components/FeaturedSolutions';

function DormRooms() {
  const navigate = useNavigate();

  return (
    <div className="page splash dormRoomsPage">
      <div className="background" />

      <div className="page-header">Dorm Rooms</div>

      <div className="text-blocks">
        <div className="std-text">
          Delight students with food and beverage at-a-click advanced ordering for
          pick-up anywhere on campus.
        </div>
        <div className="std-text">
          Fast, easy, mobile ordering and payment drives order volume and enhances
          the student experience.
        </div>
        <div className="std-text">
          Use Graphical KPI dashboards and reports to analyze performance and
          identify opportunities to improve service and operations.
        </div>
      </div>

      <FeaturedSolutions>
        <div className="featured-item" onClick={() => navigate('/solutions/ig-on-demand')}>
          <div className="item-head">
            <AgilysysLogo />
            IG OnDemand
          </div>
          <img src="/assets/higher-ed/solutions/app-ondemand-food.png" alt="" />
        </div>
      </FeaturedSolutions>
    </div>
  );
}

export default DormRooms;
